import "./HyperfluxProPlus.module.css";
import Header from "@/reusable_sections/Header";
import HyperfluxHero from "./sections/HyperfluxHero";
import Footer from "@/reusable_sections/Footer";
export default function HyperfluxProPlusPage() {
  return <div>
      <Header />
      <HyperfluxHero />
      <Footer />
    </div>;
}